import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { BASE_URL } from '../constants';
import { signOut } from './authApiSlice';


const baseQuery = fetchBaseQuery({
  baseUrl: BASE_URL,
  credentials: 'include',
});

// Wrap the baseQuery to handle token expiration (401) globally.
const baseQueryWithAuthHandling = async (args, api, extraOptions) => {
  const result = await baseQuery(args, api, extraOptions);

  // Prevent infinite loop: ignore 401s from sign_out
  const isSignOutRequest =
    typeof args === 'string'
      ? args.includes('/sign_out')
      : args?.url?.includes('/sign_out');

  if (!isSignOutRequest && result.error && result.error.status === 401) {
    const wasLoggedIn = Boolean(api.getState().auth.userInfo?._id);

    // Only redirect if the user WAS logged in
    if (wasLoggedIn) {
      api.dispatch(signOut());

      if (typeof window !== 'undefined') {
        const current = window.location.pathname + window.location.search;
        const redirect = encodeURIComponent(current || '/');
        window.location.href = `/sign_in?sessionExpired=1&redirect=${redirect}`;
      }
    }

    // If not logged in, it's just invalid credentials — let the component handle it
  }

  return result;
};


export const apiSlice = createApi({ 
  baseQuery: baseQueryWithAuthHandling,
  keepUnusedDataFor: 300, // global default: 5-minute cache for all endpoints unless overridden
  tagTypes: ['Drive', 'Benchmark', 'User', 'Users', 'AdminLog', 'Contributor', 'BlogPost'],
  endpoints: (builder) => ({}),
});